export default {
	pageName: "DeactivateEmployees",
};
